import e from "./td-longtail-vue-components194.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var s = function() {
  var a = this, t = a._self._c, i = a._self._setupProxy;
  return i.availableState ? t("div", { staticClass: "availability-information" }, [t("div", { staticClass: "availability-information__text" }, [t("strong", { staticClass: "availability-information__stock", class: `availability-information__stock--${i.availableState.modifier}` }, [a._v(" " + a._s(i.availableState.text) + " ")]), (a.availability?.stock || 0) > 0 && i.availableState.deliveryTime ? t("span", { staticClass: "availability-information__time" }, [a._v(" | Lieferzeit: " + a._s(i.availableState.deliveryTime) + " ")]) : a._e()]), a._t("delivery-availability-mail")], 2) : a._e();
}, o = [], r = /* @__PURE__ */ l(
  e,
  s,
  o,
  !1,
  null,
  "d56cafdc"
);
const c = r.exports;
export {
  c as default
};
